var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedWaveNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 308,
    viewBox: "0 0 1440 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 210.336L34.4 226.299C68.8 242.263 137.6 274.189 206.08 292.593C274.72 311.185 342.88 316.068 411.52 289.588C480 262.921 548.8 204.702 617.28 201.51C685.92 198.505 754.08 250.338 822.72 268.555C891.2 286.771 960 270.996 1028.48 245.08C1097.12 219.163 1165.28 182.73 1233.92 176.157C1302.4 169.584 1371.2 192.871 1405.6 204.327L1440 215.97V4.82798e-06H1405.6C1371.2 4.82798e-06 1302.4 4.82798e-06 1233.92 4.82798e-06C1165.28 4.82798e-06 1097.12 4.82798e-06 1028.48 4.82798e-06C960 4.82798e-06 891.2 4.82798e-06 822.72 4.82798e-06C754.08 4.82798e-06 685.92 4.82798e-06 617.28 4.82798e-06C548.8 4.82798e-06 480 4.82798e-06 411.52 4.82798e-06C342.88 4.82798e-06 274.72 4.82798e-06 206.08 4.82798e-06C137.6 4.82798e-06 68.8 4.82798e-06 34.4 4.82798e-06H0V210.336Z",
    fill: "#EF6D58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWaveNew);
export default __webpack_public_path__ + "static/media/red-wave-new.d26a77517ddb8b2ea14215a734333552.svg";
export { ForwardRef as ReactComponent };